import React from 'react';

// Buy-extra-barber modal — surfaces the price receipt (base + extra
// line-item + new monthly total) and confirms the Stripe subscription
// item update. Only reachable on Premium at cap with room to grow.
export const BuyExtraModal = ({
  capacity, extras, extraPrice, premiumBase,
  buying, buyError, onCancel, onConfirm,
}) => (
  <div className="barber-form-modal" data-testid="buy-extra-modal">
    <div className="barber-form-content">
      <h3>Add extra barber slot</h3>
      <p style={{ fontSize: 13.5, color: 'var(--mute)', margin: '4px 0 14px' }}>
        Your Premium plan includes {capacity.included} barbers.
        You&apos;ve used all {capacity.cap}. Add another chair for
        <b> £{extraPrice}/mo</b>.
      </p>
      <div
        style={{
          border: '1px solid var(--line)',
          background: 'var(--paper)',
          borderRadius: 13,
          padding: '14px 16px',
          margin: '0 0 14px',
          fontSize: 13,
        }}
        data-testid="buy-extra-receipt"
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
          <span>Premium base</span>
          <b>£{premiumBase}/mo</b>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
          <span>Extra barbers ({extras + 1} × £{extraPrice})</span>
          <b>£{(extras + 1) * extraPrice}/mo</b>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          borderTop: '1px solid var(--line)',
          paddingTop: 8,
          marginTop: 4,
          fontSize: 14,
        }}>
          <span>New monthly total</span>
          <b data-testid="buy-extra-new-total">£{premiumBase + (extras + 1) * extraPrice}/mo</b>
        </div>
        <div style={{ color: 'var(--mute)', marginTop: 8, fontSize: 12 }}>
          Prorated for the current period on your next invoice.
        </div>
      </div>
      {buyError && (
        <div className="modal-error" style={{ marginBottom: 10 }} data-testid="buy-extra-error">{buyError}</div>
      )}
      <div className="form-actions">
        <button
          type="button"
          className="btn s"
          onClick={onCancel}
          disabled={buying}
          data-testid="buy-extra-cancel"
        >Cancel</button>
        <button
          type="button"
          className="btn p"
          onClick={onConfirm}
          disabled={buying}
          data-testid="buy-extra-confirm"
        >{buying ? 'Adding…' : `Confirm & add £${extraPrice}/mo`}</button>
      </div>
    </div>
  </div>
);
